import { defineStore, acceptHMRUpdate } from 'pinia';
import useUiMsgboxStore from '@/stores/ui/msgbox';
import i18n from '@/js/plugins/i18n';

const store = defineStore('holidays', {
  state: () => ({
    byUser: {
      // XXX: [{ id, icon, title, start, end, occupancy, description }],
    },
  }),

  getters: {
    icons: () => [
      { id: 'holiday', color: 'white', label: i18n.global.t('HR.VACATION'), name: 'far fa-umbrella-beach' },
      { id: 'training', color: 'white', label: i18n.global.t('HR.TRAINING'), name: 'far fa-users-class' },
      { id: 'parttime', color: 'white', label: i18n.global.t('HR.PART_TIME'), name: 'far fa-hourglass-half' },
    ],
  },

  actions: {
    set({ userId, holidays }) {
      this.byUser[userId] = _.sortBy(holidays || [], 'start');
    },

    async load() {
      return window.apiSrv.call('useroptions/holidays/all', 'index').then((response) => {
        Object.entries(response?.data?.useroptions?.values || {}).forEach(([userId, value]) => {
          this.set({ userId, holidays: value });
        });
      });
    },

    save(userId) {
      return window.apiSrv.call('useroptions', 'update', { id: 'holidays', user_id: userId, value: this.byUser[userId] }).catch((message) => {
        if (message) useUiMsgboxStore().open({ title: "Error : Holidays were not modified", body: message || "" });
        throw message;
      });
    },
  },
});

if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(store, import.meta.hot));
export default store;
